import { ItemCountingLineDTO } from '../api/api';
import WorkClient from '../api/workClient';

const getItemCounting = () => {
  return WorkClient.getItemCounting();
};

const deleteItemCounting = () => {
  return WorkClient.deleteItemCounting();
};

const addItemCountingLine = (body: ItemCountingLineDTO) => {
  return WorkClient.addItemCountingLine(body);
};

const updateItemCountingLine = (body: ItemCountingLineDTO) => {
  return WorkClient.updateItemCountingLine(body);
};

const deleteItemCountingLine = (itemId: string) => {
  return WorkClient.deleteItemCountingLine(itemId);
};

const submitItemCounting = () => {
  return WorkClient.submitItemCounting();
};

const ItemCountingService = {
  getItemCounting,
  deleteItemCounting,
  addItemCountingLine,
  updateItemCountingLine,
  deleteItemCountingLine,
  submitItemCounting
};

export default ItemCountingService;
